export default __webpack_public_path__ + "static/media/Sofia.755311f8.png";